<ng-container *ngIf="terms$ | async"></ng-container>
<ng-container *ngIf="integrations$ | async"></ng-container>
<div class="wizard-terms">
  <h5 class="wizard-heading-1">{{ "import_terms" | translation }}</h5>

  <div
    class="wizard-terms-integrations-processing-terms-wrapper"
    *ngIf="integrationsStillGatheringTerms?.length"
  >
    <ng-container>
      <label>{{ "integrations_still_gathering_terms" | translation }}</label>
      <div class="wizard-terms-integrations-processing-terms-container">
        <span
          *ngFor="
            let integration of integrationsStillGatheringTerms;
            let i = index
          "
          >{{
            integration?.value?.friendly_name ||
              integration?.value?.friendlyName ||
              integration?.value?.name
          }}
          {{ i !== integrationsStillGatheringTerms.length - 1 ? "," : "" }}
        </span>
      </div>
    </ng-container>
  </div>

  <ng-container *ngIf="isInitialLoad; else termsTable"
    ><div class="wizard-terms-loading-container">
      <i class="fas fa-spinner fa-spin" style="font-size: 22px"></i>
    </div>
  </ng-container>
  <ng-template #termsTable>
    <ng-container *ngIf="!rows.length && !isProcessing; else defaultview">
      No Terms to import
    </ng-container>
    <ng-template #defaultview>
      <div class="loading-table-wrapper">
        <div
          class="loading-table-overlay-spinner-container"
          *ngIf="isProcessing"
        >
          <i class="fas fa-spinner fa-spin loading-table-overlay-spinner"></i>
        </div>
        <div [ngClass]="{ 'loading-table-overlay': isProcessing }">
          <ng-container *ngIf="rows.length">
            <p class="wizard-content">
              {{ "wizard_terms_explanation" | translation }}
            </p>

            <div class="wizard-terms-top-row">
              <nb-form-field>
                <input
                  (keyup.enter)="initSearch()"
                  nbInput
                  [placeholder]="'search' | translation"
                  type="text"
                  [(ngModel)]="searchTerm"
                />
                <button
                  style="background-color: transparent"
                  nbSuffix
                  nbButton
                  ghost
                  status="basic"
                  (click)="initSearch()"
                  type="button"
                >
                  <i class="fa-thin fa-magnifying-glass"></i>
                </button>
              </nb-form-field>
              <nb-select
                [(ngModel)]="selectedState"
                (selectedChange)="updateSelectedState($event)"
              >
                <nb-option value=""> {{ "both" | translation }} </nb-option>
                <nb-option value="selected">
                  {{ "selected" | translation }}</nb-option
                >
                <nb-option value="notselected">
                  {{ "unselected" | translation }}</nb-option
                >
              </nb-select>
              <div class="wizard-terms-count-label" *ngIf="itemCount">
                {{ getCountLabel() }}
              </div>
            </div>
            <table class="wizard-terms-table">
              <thead>
                <tr>
                  <ng-container *ngFor="let header of tableHeaders">
                    <ng-container *ngIf="header === columns.IsSelected">
                      <th style="width: 20px"></th>
                    </ng-container>
                    <ng-container *ngIf="header !== columns.IsSelected">
                      <th
                        style="cursor: default"
                        *ngIf="header === columns.Integration"
                      >
                        {{ header | translation }}
                      </th>
                      <th
                        (click)="sortOnHeader(header)"
                        *ngIf="header !== columns.Integration"
                      >
                        {{ header | translation }}
                        <ng-container *ngIf="header === sortOn">
                          <i
                            style="padding: 0px 5px"
                            class="fas"
                            [ngClass]="{
                              'fa-caret-down': sortAsc,
                              'fa-caret-up': !sortAsc
                            }"
                          >
                          </i>
                        </ng-container>
                      </th>
                    </ng-container>
                  </ng-container>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of rows">
                  <td *ngFor="let header of tableHeaders" [ngSwitch]="header">
                    <ng-container *ngIf="header === columns.IsSelected">
                      <nb-checkbox
                        class="background-color-secondary"
                        [checked]="row[header]"
                        (checkedChange)="updateSelected(row)"
                      ></nb-checkbox>
                    </ng-container>

                    <ng-container
                      *ngIf="
                        header === columns.Name ||
                        header === columns.Integration
                      "
                      >{{ row[header] }}</ng-container
                    >
                    <ng-container
                      *ngIf="
                        header !== columns.Name &&
                        header !== columns.Integration &&
                        header !== columns.IsSelected
                      "
                    >
                      {{
                        !row[header] ? "" : (row[header] | date : "MM/dd/yyyy")
                      }}</ng-container
                    >
                  </td>
                </tr>
              </tbody>
            </table>

            <scaffold-paginator
              (activePageChange)="activePageChange($event)"
              [itemCount]="itemCount"
              [(activePage)]="currentPage"
              [perPage]="itemsPerPage"
            ></scaffold-paginator>
          </ng-container>
        </div>
      </div>
    </ng-template>
  </ng-template>
</div>
